import { supabase } from './supabase';

const BUCKET = 'portfolio-uploads';

async function listAllFiles(path) {
  // list files in the folder (non-recursive). If your storage structure nests deeper,
  // you may need a recursive listing. For most simple cases this is enough.
  const { data, error } = await supabase.storage.from(BUCKET).list(path, { limit: 1000 });
  if (error) throw error;
  return data || [];
}

async function deleteFiles(paths) {
  if (!paths || paths.length === 0) return { count: 0 };
  const { error } = await supabase.storage.from(BUCKET).remove(paths);
  if (error) throw error;
  return { count: paths.length };
}

export async function clearUserPortfolio(userId) {
  if (!userId) throw new Error('userId is required');
  const folderPath = `portfolios/${userId}`;
  try {
    console.log(`Clearing portfolio for new user: ${userId}`);
    const items = await listAllFiles(folderPath);
    if (!items || items.length === 0) {
      console.log(`No files to delete for user ${userId}`);
      return { deleted: 0 };
    }

    // Build paths for files found
    const filePaths = items.map((it) => `${folderPath}/${it.name}`);

    const res = await deleteFiles(filePaths);
    console.log(`Deleted ${res.count} file(s) for user ${userId}`);
    return { deleted: res.count };
  } catch (err) {
    console.error(`Failed to clear portfolio for user ${userId}:`, err.message || err);
    throw err;
  }
}

export function initNewUserCleanup() {
  // Subscribe to auth changes and run cleanup if user was just created (within 60s)
  const { data: sub } = supabase.auth.onAuthStateChange(async (event, session) => {
    try {
      if (event !== 'SIGNED_IN') return;
      const user = session?.user;
      if (!user) return;

      // If user.created_at is very recent, treat as newly created
      const createdAt = user.created_at ? new Date(user.created_at) : null;
      if (!createdAt) return;
      const now = new Date();
      const secondsSinceCreate = (now - createdAt) / 1000;

      if (secondsSinceCreate <= 60) {
        // Run once
        try {
          await clearUserPortfolio(user.id);
          console.log(`Portfolio cleared for new user ${user.id}`);
        } catch (err) {
          console.error('Error clearing new user portfolio:', err.message || err);
        }
      }
    } catch (err) {
      console.error('initNewUserCleanup handler error:', err);
    }
  });

  return sub;
}
